import EditorCustom from '@/components/EditorCustom';
import { Icon, Text, TextField } from '@shopify/polaris';
import { ChevronRightIcon } from '@shopify/polaris-icons';
import { TFunction } from 'i18next';
import { ReactElement, useCallback } from 'react';
import userPlans from '@/hooks/userPlans';
interface TranslationProps {
  label: string | ReactElement;
  defaultValue?: string;
  value: string;
  loading: boolean;
  loadingPreview: boolean;
  onChange?: (newValue: string) => void;
  t?: TFunction;
  showTextField?: boolean;
  disabled?: boolean;
}

function TextFieldTranslation({ ...props }: TranslationProps) {
  const { isUserFree, isUserFreeOrBasic } = userPlans();

  const handleTranslate = useCallback(
    (newValue: string) => {
      if (props.onChange) {
        props.onChange(newValue);
      }
    },
    [props],
  );
  return (
    <div className="space-between align-center">
      <div className="width-100">
        <div className="mb-8">
          <Text variant="bodyMd" as="p">
            {props.t ? props.t(props.label as string) : props.label}
          </Text>
        </div>
        <TextField
          label=""
          autoComplete="off"
          value={props.t ? props.t(props.defaultValue as string) : props.defaultValue}
          disabled={true}
          loading={props.loadingPreview}
        />
      </div>
      <div className="ml-4 mr-4 mt-24">
        <Icon source={ChevronRightIcon} />
      </div>
      <div className="width-100">
        <div className="mb-4">
          <Text variant="bodyMd" as="p">
            {props.label}
          </Text>
        </div>
        {props?.showTextField ? (
          <TextField
            label=""
            autoComplete="off"
            value={props.value}
            onChange={handleTranslate}
            loading={props.loading}
            disabled={props.disabled}
          />
        ) : (
          <EditorCustom
            value={props.value}
            minHeight="60px"
            onChange={handleTranslate}
            disabledFontFamily={isUserFreeOrBasic}
            disabledColor={isUserFree}
            disabledFontSize={isUserFree}
            disabledEditor={props.disabled}
          />
        )}
      </div>
    </div>
  );
}

export default TextFieldTranslation;
